import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createBlock as _createBlock, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d0c129d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "preview-error"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]

import { computed, ref } from 'vue'
import { getImagePreview, getVideoPreview, getPdfPagePreview } from '@/utils/transformationUtils'
import { storeToRefs } from 'pinia'
import { useMediaManagerStore } from '@/stores'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const mediaManagerStore = useMediaManagerStore()

// State
const { assetToPreview: asset } = storeToRefs(mediaManagerStore)
const previewIsLoading = ref(true)
const hasError = ref(false)
const pageCount = computed(() => asset.value?.pages || 1)
const currentPage = ref(1)

// Functions
function goToPreviousPage () {
  if (asset.value?.format === 'pdf' && currentPage.value > 1) {
    currentPage.value--
    previewIsLoading.value = true
  }
}

function goToNextPage () {
  if (asset.value?.format === 'pdf' && currentPage.value < pageCount.value) {
    currentPage.value++
    previewIsLoading.value = true
  }
}

function close () {
  // Reset state before close
  previewIsLoading.value = true
  hasError.value = false
  currentPage.value = 1
  asset.value = null
}

return (_ctx: any,_cache: any) => {
  const _component_c_spinner = _resolveComponent("c-spinner")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_c_dialog_close_btn = _resolveComponent("c-dialog-close-btn")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    "model-value": !!_unref(asset),
    class: "c-dialog",
    "onUpdate:modelValue": close,
    onKeydown: [
      _withKeys(goToNextPage, ["right"]),
      _withKeys(goToPreviousPage, ["left"])
    ]
  }, {
    default: _withCtx(() => [
      (_unref(asset))
        ? (_openBlock(), _createBlock(_component_q_card, {
            key: 0,
            class: "preview-card"
          }, {
            default: _withCtx(() => [
              (hasError.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t('common.error_loading_asset')), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_q_inner_loading, { showing: previewIsLoading.value }, {
                      default: _withCtx(() => [
                        _createVNode(_component_c_spinner)
                      ]),
                      _: 1
                    }, 8, ["showing"]),
                    (_unref(asset).format === 'pdf')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("img", {
                            src: _unref(getPdfPagePreview)(_unref(asset), currentPage.value),
                            alt: "",
                            class: "preview-image",
                            onLoad: _cache[0] || (_cache[0] = ($event: any) => (previewIsLoading.value = false)),
                            onError: _cache[1] || (_cache[1] = ($event: any) => (hasError.value = true))
                          }, null, 40, _hoisted_2),
                          (!previewIsLoading.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _withDirectives(_createVNode(_component_q_icon, {
                                  class: "pdf-nav-button is-previous",
                                  name: "inri-chevron-left",
                                  onClick: goToPreviousPage
                                }, null, 512), [
                                  [_vShow, currentPage.value > 1]
                                ]),
                                _withDirectives(_createVNode(_component_q_icon, {
                                  class: "pdf-nav-button is-next",
                                  name: "inri-chevron-right",
                                  onClick: goToNextPage
                                }, null, 512), [
                                  [_vShow, currentPage.value < _unref(pageCount)]
                                ])
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_unref(asset).resourceType === 'image')
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: _unref(getImagePreview)(_unref(asset)),
                            alt: "",
                            class: "preview-image",
                            onLoad: _cache[2] || (_cache[2] = ($event: any) => (previewIsLoading.value = false)),
                            onError: _cache[3] || (_cache[3] = ($event: any) => (hasError.value = true))
                          }, null, 40, _hoisted_3))
                        : (_unref(asset).resourceType === 'video')
                          ? _withDirectives((_openBlock(), _createElementBlock("video", {
                              key: 2,
                              controls: "",
                              class: "preview-video",
                              onLoadeddata: _cache[6] || (_cache[6] = ($event: any) => (previewIsLoading.value = false))
                            }, [
                              _createElementVNode("source", {
                                src: _unref(getVideoPreview)(_unref(asset), '.webm'),
                                type: "video/webm",
                                onError: _cache[4] || (_cache[4] = ($event: any) => (hasError.value = true))
                              }, null, 40, _hoisted_4),
                              _createElementVNode("source", {
                                src: _unref(getVideoPreview)(_unref(asset), '.mp4'),
                                type: "video/mp4",
                                onError: _cache[5] || (_cache[5] = ($event: any) => (hasError.value = true))
                              }, null, 40, _hoisted_5)
                            ], 544)), [
                              [_vShow, !previewIsLoading.value]
                            ])
                          : _createCommentVNode("", true),
                    _createVNode(_component_c_dialog_close_btn, { onClick: close })
                  ], 64))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value", "onKeydown"]))
}
}

})